import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import KYCModal from '../components/KYCModal';

// Componente para el modal de requisitos (versión simplificada)
const RequirementsModal = ({ isOpen, onClose }) => {
   if (!isOpen) return null;

   // Handler para cerrar el modal cuando se hace clic fuera del contenido
   const handleOverlayClick = (e) => {
      // Solo cerramos si el clic fue directamente en el overlay, no en su contenido
      if (e.target.className === 'modal_overlay') {
         onClose();
      }
   };

   return (
      <div className="modal_overlay" onClick={handleOverlayClick}>
         <div className="modal_content">
            <div className="modal_content_header">
               <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            <div className="modal_content_body">
               <h3 className="ppt_form_title mb-5 text-center">Documents you will need</h3>
               <ol className="ppt_list_gen">
                  <li>Government ID or passport</li>
                  <li>Smartphone or webcam required for Face ID verification.</li>
                  <li>Bank statement with your name and address, dated within the last month.</li>
                  <li>Utility bill (internet, water, or electricity) with your address, dated within the last three months.</li>
               </ol>
               <div className="d-flex justify-content-center pt-4">
                  <button onClick={onClose} className="ppt_btn_primary alt">Close</button>
               </div>
            </div>
         </div>
      </div>
   );
};

const steps = [
   { key: 'yourDetails', label: 'Your Details' },
   { key: 'pricingFees', label: 'Pricing & Fees' },
   { key: 'termsConditions', label: 'Terms & Conditions' },
   { key: 'reviewVerify', label: 'Review & Verify' },
   { key: 'idVerification', label: 'ID Verification' },
   { key: 'uploadDocuments', label: 'Upload Documents' },
   { key: 'foundingDetails', label: 'Funding Details' }
];

function KYC() {
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isRequirementsModalOpen, setIsRequirementsModalOpen] = useState(false);
   const [currentStep, setCurrentStep] = useState(1);
   const [stepsStatus, setStepsStatus] = useState({});
   const [stepsCompleted, setStepsCompleted] = useState(0);
   const [isKYCCompleted, setIsKYCCompleted] = useState(false);

   const totalSteps = steps.length || 1;
   const percentComplete =
      typeof stepsCompleted === 'string' && stepsCompleted.includes('%')
         ? stepsCompleted
         : (totalSteps > 0
            ? Math.round((Number(stepsCompleted) / totalSteps) * 100) + '%'
            : '0%');

   // Refrescar pasos
   const fetchStepsStatus = async () => {
      const jwt = localStorage.getItem('jwt');
      const res = await fetch('https://pt-api.digit-a.net/api/steps/get-steps-status', {
         headers: {
            'Authorization': `Bearer ${jwt}`,
            'Content-Type': 'application/json'
         }
      });
      const data = await res.json();

      // Guardar si el KYC está completado o no
      setIsKYCCompleted(!!data.isCompleted);

      const statusObj = {};
      if (Array.isArray(data.steps)) {
         data.steps.forEach(stepObj => {
            const key = Object.keys(stepObj)[0];
            statusObj[key] = stepObj[key];
         });
      }
      setStepsStatus(statusObj);
      setStepsCompleted(data.stepsCompleted || 0);
      return statusObj;
   };

   useEffect(() => {
      fetchStepsStatus();
   }, []);

   // Handler for the regular KYC modal
   const handleOpenModal = () => {
      setCurrentStep(1);
      setIsModalOpen(true);
   };

   // Handler for the requirements modal
   const handleViewRequirements = (e) => {
      e.preventDefault();
      setIsRequirementsModalOpen(true);
   };

   return (
      <div className="container-fluid max py-lg-5" page-key="KYC">
         <div className="row mb-3 justify-content-between">
            <div className="col col-lg-3">
               <NavLink to="/dashboard" className="">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                  <small className="d-block" style={{ color: 'var(--white)', opacity: '0.5' }}>ProperT LLC - Prueba</small>
               </NavLink>
            </div>
            <div className="col-auto">
               <DarkModeBtn />
            </div>
         </div>
         <div className="row mb-3 mb-lg-5 justify-content-between align-items-center">
            <div className="col">
               <h3 className="ppt_form_title mb-0 fs-2"><b>KYC</b></h3>
            </div>
            <div className="col-auto container_btn_kyc">
               <NavLink to="/dashboard" className="ppt_btn_primary alt mx-auto d-table">Dashboard</NavLink>
            </div>
         </div>
         <div className="row mb-5 flex-column-reverse flex-lg-row">
            <div className="col">
               <div className="ppt_box_gen h-100">
                  <div className="d-flex flex-column text-centerd-flex flex-column text-center col-lg-8 mx-auto p-2 py-lg-4 px-lg-0 mb-3 mb-lg-5">
                     <h3 className="ppt_form_title mb-3">Complete Onboarding To Gain Full Access to ProperT</h3>
                     <p className="mb-5">Based on your location, you can onboard onto the following set of assets:</p>
                     <div className="ppt_box_gen mb-4 mb-lg-5">
                        <p className="mb-1"><b>Asset Package</b></p>
                        <h3 className="ppt_form_title mb-3">Stablecoin Solutions</h3>
                        <span className="ppt_scs_icons">
                           <span><img src={process.env.PUBLIC_URL + '/assets/img/icon_ppt_small.svg'} alt="" /> ProperT</span>
                           <span><img src={process.env.PUBLIC_URL + '/assets/img/icon_ppt_gold.svg'} alt="" /> GoldT</span>
                           <span><img src={process.env.PUBLIC_URL + '/assets/img/icon_ppt_silver.svg'} alt="" /> SilverT</span>
                        </span>
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_check_ylw.svg'} alt="" data-lightmodeimg />
                     </div>
                     <NavLink to="/" className="d-flex w-100 align-items-center gap-3 justify-content-center t-wht">
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_play_video.svg'} alt="" data-lightmodeimg />
                        Watch video
                     </NavLink>
                  </div>
                  <span className="ppt_box_gen_footer mt-auto">
                     <p className="mb-0"><b className="d-block">Don't see what you're looking for?</b> Happy to help you, simply send us a message. </p>
                     <NavLink to="/" className="ppt_btn_secondary">Contact Sales</NavLink>
                  </span>
               </div>
            </div>
            <div className="col mb-4 mb-lg-0">
               <div className="ppt_box_gen h-100">
                  <div className="d-flex flex-column text-centerd-flex flex-column col-lg-11 mx-lg-auto py-lg-4 mb-lg-5">
                     <span className="d-flex align-items-center justify-content-between mb-2 mb-lg-5 flex-column flex-lg-row">
                        <span className="d-flex align-items-center gap-2 gap-lg-3">
                           <span
                              className="ppt_circle"
                              style={{
                                 backgroundImage: `conic-gradient(from 0deg at 50% 50%, var(--ppt_cicle_col_2) ${percentComplete}, var(--ppt_cicle_col_1) ${percentComplete})`
                              }}
                           >
                              <span
                                 className="ppt_circle_inner"
                                 data-complete={percentComplete}
                              ></span>
                           </span>

                           <p className="mb-0">
                              {isKYCCompleted ? (
                                 <b className="d-block">KYC Completed</b>
                              ) : (
                                 <>
                                    <b className="d-block">20 Minutes</b> Estimated Time to Complete.
                                 </>
                              )}
                           </p>
                        </span>

                        {/* Renderizado condicional del botón, solo si no está completado */}
                        {!isKYCCompleted && (
                          <button
                            onClick={handleOpenModal}
                            className="ppt_btn_primary alt ms-auto ms-lg-0"
                          >
                            Get Started
                          </button>
                        )}
                     </span>
                     <ol>
                        {steps.map((step, idx) => (
                           <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {step.label}
                              {stepsStatus[step.key] && (
                                 <img
                                    src={process.env.PUBLIC_URL + '/assets/img/icon_complete.svg'}
                                    alt="Completado"
                                 />
                              )}
                           </li>
                        ))}
                     </ol>
                  </div>

                  <span className="ppt_box_gen_footer mt-auto">
                    <p className="mb-0"><b className="d-block">Unsure you have everything you need?</b> Visit our docs site to view requirements.</p>
                    {isKYCCompleted ? (
                      // Versión deshabilitada cuando KYC está completo
                      <span
                        className="text_under text-muted"
                        style={{ cursor: 'not-allowed', opacity: 0.6, textDecoration: 'none' }}
                      >
                        View onboarding<br /> requirements
                      </span>
                    ) : (
                      // Versión normal cuando KYC no está completo
                      <NavLink
                        to="/"
                        className="text_under"
                        onClick={handleViewRequirements}
                      >
                        View onboarding<br /> requirements
                      </NavLink>
                    )}
                  </span>
               </div>
            </div>
         </div>

         {/* Regular KYC modal */}
         <KYCModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            stepsStatus={stepsStatus}
            stepsCompleted={stepsCompleted}
            refreshStepsStatus={fetchStepsStatus}
         />

         {/* Requirements-only modal */}
         <RequirementsModal
            isOpen={isRequirementsModalOpen}
            onClose={() => setIsRequirementsModalOpen(false)}
         />
      </div>
   );
}

export default KYC;